import { render, staticRenderFns } from "./ProductsCard.vue?vue&type=template&id=7f5836e4&"
import script from "./ProductsCard.vue?vue&type=script&lang=js&"
export * from "./ProductsCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports